// removed by extract-text-webpack-plugin
module.exports = {"bg-white":"app-pages-Library-Item-ItemDetail-ItemForm-ItemInventoryAlert-ItemInventoryAlertFieldArray-ItemInventoryAlertField-__ItemInventoryAlertField___2R_5H"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Library/Item/ItemDetail/ItemForm/ItemInventoryAlert/ItemInventoryAlertFieldArray/ItemInventoryAlertField/ItemInventoryAlertField.css
// module id = 2425
// module chunks = 0